<template>
  <layout-switcher
    :trigger-color="header ? header.accentColor : ''"
    :components="workspaceComponentsByKey"
    :workspaces="workspacesById"
    :default-workspaces="defaultWorkspacesById"
    :active-workspace="activeWorkspace ? activeWorkspace.key : ''"
    @link-click="onActiveWorkspaceChange"
    @layout-select="onLayoutSelect"
    @layout-bookmark="onLayoutBookmark"
    @layout-reset="onLayoutReset"
    @layout-delete="onLayoutDelete"
    @layout-create="onLayoutCreate"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue-demi';
import { useUILayoutSettings } from '@/modules/settings-store';

import { LayoutSwitcher } from '../components';
import { useLayoutSwitcher } from '../composables/use-layout-switcher';

export default defineComponent({
  name: 'LayoutSwitcherContainer',
  components: { LayoutSwitcher },
  setup() {
    const {
      workspaceComponentsByKey,
      workspacesById,
      defaultWorkspacesById,
      activeWorkspace,
      onActiveWorkspaceChange,
      onLayoutSelect,
      onLayoutBookmark,
      onLayoutReset,
      onLayoutDelete,
      onLayoutCreate,
    } = useLayoutSwitcher();
    const { layoutHeader, resetUILayoutSettings } = useUILayoutSettings();

    return {
      resetUILayoutSettings,
      header: layoutHeader,
      workspaceComponentsByKey,
      workspacesById,
      defaultWorkspacesById,
      activeWorkspace,
      onActiveWorkspaceChange,
      onLayoutSelect,
      onLayoutBookmark,
      onLayoutReset,
      onLayoutDelete,
      onLayoutCreate,
    };
  },
});
</script>
